var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.25012L8.33325 8.75012L11.6666 10.4168L9.16659 12.9168M16.6666 10.0001C16.6666 14.0905 12.205 17.0654 10.5816 18.0125C10.3971 18.1201 10.3048 18.174 10.1747 18.2019C10.0736 18.2235 9.92622 18.2235 9.82519 18.2019C9.695 18.174 9.60275 18.1201 9.41826 18.0125C7.79489 17.0654 3.33325 14.0905 3.33325 10.0001V6.01478C3.33325 5.34852 3.33325 5.01539 3.44222 4.72904C3.53848 4.47607 3.6949 4.25035 3.89797 4.07139C4.12783 3.86882 4.43975 3.75185 5.06359 3.51791L9.53175 1.84234C9.705 1.77738 9.79162 1.74489 9.88074 1.73202C9.95978 1.72059 10.0401 1.72059 10.1191 1.73202C10.2082 1.74489 10.2948 1.77738 10.4681 1.84234L14.9362 3.51791C15.5601 3.75185 15.872 3.86882 16.1019 4.07139C16.3049 4.25035 16.4614 4.47607 16.5576 4.72904C16.6666 5.01539 16.6666 5.34852 16.6666 6.01478V10.0001Z",
    stroke: "#E9BE5C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.ab78528a8f1c0749235180480f7cb74c.svg";
export { ForwardRef as ReactComponent };